import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const ClassService = {
    getByDepartmentId: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Class/GetByDepartmentId/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : error.message);
        }
    },
};

export default ClassService;
